export const ITEM_LIST_STATES = {
  PAGINATION: "pagination",
  SORT_AND_REFINEMENT: "sort_and_refinement",
  SORT: "sort",
  REFINEMENT: "refinement",
  GENERIC_SEARCH: "generic_search",
  SEARCH: "search",
  CATEGORY: "category",
};

const PAGE_TYPES = {
  SEARCH: "search",
  CATEGORY: "category",
};

export function getViewItemListState({
  pageType,
  searchTerm,
  currentPageNumber,
  hasSort = false,
  hasAppliedRefinements = false,
}) {
  if (currentPageNumber !== null && currentPageNumber > 1) {
    return ITEM_LIST_STATES.PAGINATION;
  }

  if (hasSort && hasAppliedRefinements) {
    return ITEM_LIST_STATES.SORT_AND_REFINEMENT;
  }

  if (hasSort) {
    return ITEM_LIST_STATES.SORT;
  }

  if (hasAppliedRefinements) {
    return ITEM_LIST_STATES.REFINEMENT;
  }

  if (pageType === PAGE_TYPES.SEARCH) {
    if (!searchTerm) {
      return ITEM_LIST_STATES.GENERIC_SEARCH;
    }

    return ITEM_LIST_STATES.SEARCH;
  }

  if (pageType === PAGE_TYPES.CATEGORY) {
    return ITEM_LIST_STATES.CATEGORY;
  }

  return undefined;
}
